import api from "./api";

export const FichaService = {
  save: (data) => {
    return api.post("/ficha/solicitacao", data);
  },

  getFichaSuperior: (id) => {
    return api.get("/ficha/approvalHigher", { params: { id } });
  },

  resendEmail: (id) => {
    return api.post(`/ficha/email/resend?fichaId=${id}`);
  },

  saveAprovacaoSuperior: ({
    id,
    nome,
    nivel,
    observacao,
    matricula,
    cpf,
    aprovado,
  }) => {
    return api.post(`/ficha/saveApprovalHigher?id=${id}`, {
      nome,
      nivel,
      observacao,
      matricula,
      cpf,
      aprovado,
    });
  },

  getListComissaoSip3w: ({ page, size, nome, cpf, sistema }) => {
    return api.get("/ficha/comssiaoSip3w", {
      params: { page, size, nome, cpf, sistema },
    });
  },

  aprovacaoComissaoSip3w: ({ id, nome, cpf, observacao, aprovado, nivel }) => {
    return api.post(`/ficha/comssiaoSip3w?id=${id}`, {
      nome,
      cpf,
      observacao,
      aprovado,
      nivel,
    });
  },

  getListInteligenciaDip: ({ page, size, nome, cpf, sistema }) => {
    return api.get(`/ficha/inteligenciaDip`, {
      params: { page, size, nome, cpf, sistema },
    });
  },

  aprovacaoInteligencia: ({
    id,
    nome,
    cpf,
    observacao,
    orgao,
    aprovado,
    nivel,
  }) => {
    return api.post(`/ficha/inteligencia?id=${id}`, {
      nome,
      cpf,
      observacao,
      orgao,
      aprovado,
      nivel,
    });
  },

  aprovacaoSecretario: ({ id, nome, cpf, observacao, aprovado, nivel }) => {
    return api.post(`/ficha/secretario?id=${id}`, {
      nome,
      cpf,
      observacao,
      aprovado,
      nivel,
    });
  },

  aprovacaoTodosSecretario: ({ nome, cpf }) => {
    return api.post(`/ficha/secretario/aproveAll`, {
      nome,
      cpf,
      aprovado: true,
    });
  },

  executadoCotic: ({ id, nome, cpf, observacao, aprovado }) => {
    return api.post(`/ficha/cotic?id=${id}`, {
      nome,
      cpf,
      observacao,
      aprovado,
    });
  },

  getById: ({ id }) => {
    return api.get("/ficha", { params: { id } });
  },

  getListInteligenciaAsint: ({ page, size, nome, cpf, sistema }) => {
    return api.get(`/ficha/inteligenciaAsint`, {
      params: { page, size, nome, cpf, sistema },
    });
  },

  getListInteligenciaAssint: ({ page, size, nome, cpf, sistema }) => {
    return api.get(`/ficha/inteligenciaAssint`, {
      params: { page, size, nome, cpf, sistema },
    });
  },

  getListInteligenciaCoin: ({ page, size, nome, cpf, sistema }) => {
    return api.get(`/ficha/inteligenciaCoin`, {
      params: { page, size, nome, cpf, sistema },
    });
  },

  getListSecretarioExecutivo: ({ page, size, nome, cpf, sistema }) => {
    return api.get(`/ficha/secretario`, {
      params: { page, size, nome, cpf, sistema },
    });
  },

  getListCotic: ({ page, size, nome, cpf, sistema }) => {
    return api.get(`/ficha/cotic`, {
      params: { page, size, nome, cpf, sistema },
    });
  },

  getListAuditoria: ({
    page,
    size,
    cpfAutorizadorInteligencia,
    cpfSolicitante,
    sistema,
    isAprovados,
  }) => {
    return api.get(`/ficha/autorizadas`, {
      params: {
        page,
        size,
        cpfAutorizadorInteligencia,
        cpfSolicitante,
        sistema,
        isAprovados,
      },
    });
  },

  getIdUser: ({ id }) => {
    return api.get(`/ficha/user`, { params: { id } });
  },

  getAllByCPF: ({ cpf }) => {
    return api.get(`ficha/fichas/cpf?value=${cpf}`);
  },
  getListRotas: ({ page, size, nome, cpf, sistema }) => {
    return api.get(`/ficha/secretario`, {
      params: { page, size, nome, cpf, sistema },
    });
  },
};
